import { useContext } from "react";
import { Context } from "./context";

export function useEditorConfig() {
  const config = useContext(Context);

  if (!config) {
    throw new Error(
      "useEditorConfig must be used within a EditorConfigProvider",
    );
  }
  return config;
}
